<div class="overview-toolbar__header">
  <div class="overview-toolbar__identity">
    <h1 class="overview-toolbar__title">{{ config().title | translate }}</h1>
  </div>

  <div class="overview-toolbar__actions">
    @if (config().secondaryAction) {
      <p-button
        [label]="config().secondaryAction! | translate"
        severity="secondary"
        [disabled]="config().secondaryDisabled ?? false"
        (onClick)="secondaryClick.emit()"
      />
    }
    @if (config().primaryAction) {
      <p-button
        [label]="config().primaryAction! | translate"
        [disabled]="config().primaryDisabled ?? false"
        (onClick)="primaryClick.emit()"
      >
        <ng-template pTemplate="icon">
          <svg [lucideIcon]="lucidePlus" [size]="16"></svg>
        </ng-template>
      </p-button>
    }
  </div>
</div>

<p-toolbar class="overview-toolbar">
  <ng-template #start>
    <div class="overview-toolbar__tools">
      <p-iconfield class="overview-toolbar__search">
        <p-inputicon class="pi pi-search" />
        <input
          pInputText
          [placeholder]="searchPlaceholder()"
          [value]="searchValue()"
          (input)="onSearchInput($any($event.target).value)"
        />
      </p-iconfield>

      @for (filter of quickFilters(); track filter.key) {
        <p-select
          class="overview-toolbar__quick-filter"
          [options]="filter.options"
          [ngModel]="filterValues()[filter.key] ?? null"
          optionValue="value"
          [placeholder]="filter.placeholder ?? filter.label | translate"
          (ngModelChange)="onQuickFilterChange(filter.key, $event)"
        >
          <ng-template #selectedItem let-opt>{{ opt.label | translate }}</ng-template>
          <ng-template #item let-opt>{{ opt.label | translate }}</ng-template>
        </p-select>
      }

      @if (sortOptions().length > 0) {
        <p-select
          class="overview-toolbar__sort"
          [options]="sortOptions()"
          [ngModel]="selectedSort()"
          placeholder="Sort by"
          (ngModelChange)="onSortChange($event)"
        />
      }
    </div>
  </ng-template>

  <ng-template #end>
    <p-select-button
      class="overview-toolbar__view-toggle"
      [options]="viewOptions"
      [ngModel]="view()"
      optionValue="value"
      (ngModelChange)="onViewChange($event)"
    >
      <ng-template #item let-opt>
        <i [class]="opt.icon" [pTooltip]="opt.tooltip | translate" tooltipPosition="top"></i>
      </ng-template>
    </p-select-button>
  </ng-template>
</p-toolbar>

@if (activeFilters().length > 0) {
  <div class="overview-toolbar__chips">
    @for (filter of activeFilters(); track filter.key) {
      <p-chip [label]="filter.label" [removable]="true" (onRemove)="onFilterRemove(filter.key)" />
    }
    <p-button label="Clear all" severity="secondary" [link]="true" (onClick)="onClearAll()" />
  </div>
}
